
import React, { useEffect, useState } from 'react';
import { CssBaseline, FormControl, Grid, InputLabel, Switch, TextField, useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Controller } from 'react-hook-form';
import useStyles from '../../common/CommonStyle/CommonStyle';
import { useIntl } from 'react-intl';
import EntityCodeCombo from '../../common/Combos/EntityCodeCombo';

const CustomerBasicDetails = (props) => {
    const classes = useStyles();
    const intl = useIntl();
    const theme = useTheme();
    const { mode, errors, control, basicDetail,branchValue, setBranchValue } = props;
    const [userToBeEdited, setUserToBeEdited] = React.useState({});
    const [basicDetailsValue, setBasicDetailsValue] = useState('');
    const pageLabelsConstantsAndMessages = {
        name: {
            bpCode: "bpCode",
            bpCustomerName: "bpCustomerName",
            bpGroupName: "bpGroupName",
            customerAccountGroup: "customerAccountGroup",
            language: "language",
            currency: "currency",
            active: "active",
            organization: "organization",
            entity: 'entity',
        },
        label: {
            active: "active",
        }
    }

    const [customerReadOnlyFields, setCustomerReadOnlyFields] = useState({
        bpCode: false,
        bpCustomerName: false,
        bpGroupName: false,
        customerAccountGroup: false,
        language: false,
        currency: false,
        active: false,
        organization: false,
        entity: false,
    })

    useEffect(() => {
        setUserToBeEdited(basicDetail);
    }, [basicDetail]);

    useEffect(() => {
        if (mode === 'read' || mode === 'edit') {
            setCustomerReadOnlyFields({
                ...customerReadOnlyFields, bpCode: true, bpCustomerName: true, bpGroupName: true,
                customerAccountGroup: true, language: true, currency: true, organization: true, active: false
            })
            setBasicDetailsValue(basicDetail.organization !== undefined ? { valueToBeDisplayed: basicDetail.organization } : []);
            setBranchValue(basicDetail.entity !== undefined ? { valuesToBeDisplayed: basicDetail.entity } : []);
        }
        if (mode === 'read') {
            setCustomerReadOnlyFields({
                ...customerReadOnlyFields, active: true
            })

        }
    }, [mode, basicDetail])


    const branchComboProperty = {
        name: pageLabelsConstantsAndMessages.name.entity,
        isRequired: true,
        label: intl.formatMessage({ id: "textfield.entityCode.label" }),
        isAutofocus: false,
        isDisabled: (mode === 'read' || mode === 'edit') ? true : false,
        variant: 'outlined',
        isHookFormType: true,
        errors: errors.entity
    }
    return (
        <React.Fragment>
            <CssBaseline />
            <Grid container className={classes.root}>
                <Grid item container xs={12} sm={12} md={12} lg={12} className={classes.textfieldSpacing} style={{ marginTop: '-1%' }}>
                    <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2} className={classes.gridSpacing}>
                        <Grid item container xs={12} sm={12} md={5} lg={5}>
                            <EntityCodeCombo comboProperty={branchComboProperty} control={control} errors={errors} comboValue={branchValue} setComboValue={setBranchValue} />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2} className={classes.gridSpacing}>
                        <Grid item container xs={12} sm={6} md={5} lg={5}    >
                            <FormControl fullWidth>
                                <Controller
                                    control={control}
                                    name={pageLabelsConstantsAndMessages.name.bpCustomerName}
                                    rules={{
                                        required: true,
                                    }}
                                    render={({ field }) => (
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            margin="normal"
                                            id="bpCustomerName"
                                            size='small'
                                            required={true}
                                            label={<FormattedMessage id="columnname.textfield.customername.label" defaultMessage="BP Customer Name" />}
                                            error={errors.bpCustomerName}
                                            {...field}
                                            InputLabelProps={{
                                                shrink: true,
                                                classes: {
                                                    asterisk: classes.asterisk
                                                }
                                            }}
                                            InputProps={{
                                                readOnly: customerReadOnlyFields.bpCustomerName,
                                            }}
                                            disabled={mode === 'read' || mode === 'edit' ? true : false}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item container xs={12} sm={6} md={2} lg={2}  >
                            <FormControl fullWidth>
                                <Controller
                                    control={control}
                                    name={pageLabelsConstantsAndMessages.name.bpCode}
                                    rules={{
                                        required: true,
                                    }}
                                    render={({ field }) => (
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            margin="normal"
                                            id="bpCode"
                                            size='small'
                                            required={true}
                                            label={<FormattedMessage id="common.texfield.businesspartnercode" defaultMessage="Business Partner Code" />}
                                            {...field}
                                            InputLabelProps={{
                                                shrink: true,
                                                classes: {
                                                    asterisk: classes.asterisk
                                                }
                                            }}
                                            InputProps={{
                                                readOnly: customerReadOnlyFields.bpCode,
                                            }}
                                            disabled={mode === 'read' || mode === 'edit' ? true : false}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item container xs={12} sm={6} md={2} lg={1}>
                            <FormControl fullWidth>
                                <Controller
                                    control={control}
                                    name={pageLabelsConstantsAndMessages.name.currency}
                                    render={({ field }) => (
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            margin="normal"
                                            id="currency"
                                            size='small'
                                            label={<FormattedMessage id="common.textfield.columname.label" defaultMessage=" Currency" />}
                                            error={errors.currency}
                                            {...field}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                readOnly: customerReadOnlyFields.currency,
                                            }}
                                            disabled={mode === 'read' || mode === 'edit' ? true : false}

                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item container xs={12} sm={6} md={2} lg={2}>
                            <FormControl fullWidth>
                                <Controller
                                    control={control}
                                    name={pageLabelsConstantsAndMessages.name.customerAccountGroup}
                                    render={({ field }) => (
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            margin="normal"
                                            id="customerAccountGroup"
                                            size='small'
                                            label={<FormattedMessage id="common.textfield.columname.customergroup.label" defaultMessage=" Customer Account Group" />}
                                            error={errors.customerAccountGroup}
                                            {...field}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                readOnly: customerReadOnlyFields.customerAccountGroup,
                                            }}
                                            disabled={mode === 'read' || mode === 'edit' ? true : false}

                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item container xs={12} sm={6} md={2} lg={2}>
                            <FormControl fullWidth>
                                <Controller
                                    control={control}
                                    name={pageLabelsConstantsAndMessages.name.language}
                                    render={({ field }) => (
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            margin="normal"
                                            id="language"
                                            size='small'
                                            label={<FormattedMessage id="columnname.language.label" defaultMessage=" Language" />}
                                            error={errors.language}
                                            {...field}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                readOnly: customerReadOnlyFields.language,
                                            }}
                                            disabled={mode === 'read' || mode === 'edit' ? true : false}

                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item container xs={12} sm={6} md={3} lg={3}>
                            <FormControl fullWidth>
                                <Controller
                                    control={control}
                                    name={pageLabelsConstantsAndMessages.name.bpGroupName}
                                    render={({ field }) => (
                                        <TextField
                                            className={classes.textField}
                                            variant="outlined"
                                            margin="normal"
                                            id="bpGroupName"
                                            size='small'
                                            label={<FormattedMessage id="common.textfield.columname.bpgroupname.label" defaultMessage=" BP Group Name" />}
                                            error={errors.bpGroupName}
                                            {...field}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            InputProps={{
                                                readOnly: customerReadOnlyFields.bpGroupName,
                                            }}
                                            disabled={mode === 'read' || mode === 'edit' ? true : false}

                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item container xs={12} sm={6} md={3} lg={3}>
                            <Grid container justifyContent='flex-start' alignItems='center'>
                                <Controller
                                    render={({
                                        field: { onChange } }) => (<Switch
                                            color='primary'
                                            disabled={customerReadOnlyFields.active}
                                            checked={userToBeEdited.active !== undefined ? userToBeEdited.active : true}
                                            onChange={((event) => {
                                                onChange(!(userToBeEdited.active !== undefined ? userToBeEdited.active : true));
                                                setUserToBeEdited({ ...userToBeEdited, active: event.target.checked })

                                            })}
                                        />)}
                                    type="checkbox"
                                    name={pageLabelsConstantsAndMessages.name.active}
                                    control={control}
                                    defaultValue={userToBeEdited.active !== undefined ? userToBeEdited.active : true}
                                />
                                <InputLabel>{<FormattedMessage id="common.active.lable" defaultMessage={pageLabelsConstantsAndMessages.label.active} />}</InputLabel>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
export default CustomerBasicDetails;